import React, { Fragment } from 'react'
import AsyncSelect from 'react-select/lib/Async'

import { pxToRem, color } from '../../utils'

const customStyles = {
  control: (base, state) => ({
    ...base,
    background: 'none',
    border: '1px solid #d8d8d8',
    borderRadius: '0',
    fontFamily: `'Open Sans', sans-serif`,
    padding: pxToRem(3),
    textTransform: 'uppercase',
    minHeight: 'unset',
    height: pxToRem(35),
    fontSize: pxToRem(16)
  }),
  singleValue: (base, state) => ({
    ...base,
    textTransform: 'uppercase',
    color: color.secondary
  }),
  option: (base, state) => {
    const styles = {
      ...base,
      fontFamily: `'Open Sans', sans-serif`,
    }

    if (state.isFocused && !state.isSelected) {
      styles.background = '#f4f7f9'
    } else if (state.isSelected) {
      styles.background = color.secondary
    }

    return styles
  },
  indicatorSeparator: (base, state) => ({
    ...base,
    display: 'none'
  }),
  menu: (base, state) => ({
    ...base,
    borderRadius: '0',
    margin: '0'
  }),
  menuList: (base, state) => ({
    ...base,
    margin: '0',
    padding: '0',
    fontSize: `${pxToRem(12)}`
  }),
  noOptionsMessage: (base, state) => ({
    ...base,
    fontFamily: `'Open Sans', sans-serif`
  }),
  placeholder: (base, state) => ({
    ...base,
    fontSize: `${pxToRem(12)}`
  }),
  dropdownIndicator: (base, state) => ({
    ...base,
    display: 'none'
  })
}

const Select = props => {
  const { ...rest } = props

  return (
    <Fragment>
      <AsyncSelect
        {...rest}
        styles={customStyles}
        loadingMessage={() => {
          return 'Carregando...'
        }}
        placeholder="Buscar produtos compatíveis"
        noOptionsMessage={select => {
          return select.inputValue ? 'Produto não encontrado ou incompatível' : 'Digite o nome do produto'
        }}
      />
    </Fragment>
  )
}

export default Select



// WEBPACK FOOTER //
// ./src/components/Cabinet/Select.js